export function getRandomBg(name: string) {
  let utf8Encode = new TextEncoder();
  const sum = utf8Encode.encode(name).reduce((acc, val) => acc + val, 0);
  switch(sum % 5) {
    case 0:
      return "#6EC66D"
    case 1:
      return "#43A7EF"
    case 2:
      return "#FB5454"
    case 3:
      return "#E2A13E"
    case 4:
      return "#78839F"
    default:
      return "#78839F"
  }
}

export function getRandomColor(name: string) {
  let utf8Encode = new TextEncoder();
  const sum = utf8Encode.encode(name).reduce((acc, val) => acc + val, 0);
  switch(sum % 5) {
    case 0:
      return "#56AE54"
    case 1:
      return "#1D88D5"
    case 2:
      return "#E53030"
    case 3:
      return "#D58B1D"
    case 4:
      return "#78839F"
    default:
      return "#78839F"
  }
}
